// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"358":"LanguageSelectionModal","524":"CurrencySelectionModal","650":"LocaleMessageModal","680":"LocaleMessageContent"}[chunkId] + "." + {"358":"48f2c79696e9598cc6bb","524":"b7c3046edeafd7d53247","650":"4539ce38815eee612493","680":"c3705831205317e2c024"}[chunkId] + ".js";
};